<div class="algorith-section-title">
  <div class="title">{{constants.text.ALGORITHM}}</div>
  <div class="note">{{constants.text.NOTE}}</div>
</div>

<div class="algorith-section-content">
  <form [formGroup]="algorithmForm" class="algoForm" >
    
    <!-- Algorithm Dropdown -->
    <div class="form-field">
      <p class="label">
        {{constants.text.ALGORITHM}}
        <span class="required" *ngIf="!algorithmForm.get('algorithm')?.value && mode === CONFIG_MODE.CREATE">*</span>
      </p>
      
      <mat-form-field appearance="fill">
        <mat-select
          formControlName="algorithm"
          placeholder="Select Algorithm"
          (selectionChange)="onAlgorithmSelected($event)"
        >
          <mat-option [value]="null" disabled>{{constants.text.SELECT_ALGORITHM}}</mat-option>
          <mat-option *ngFor="let option of algorithmList" [value]="option">
            {{ option.alias }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Version Dropdown -->
    <div class="form-field">
      <p class="label">
        {{constants.text.VERSIONS}}
        <span class="required" *ngIf="!algorithmForm.get('version')?.value && mode === CONFIG_MODE.CREATE">*</span>
      </p>
      
      <mat-form-field appearance="fill">
        <mat-select
          formControlName="version"
          placeholder="Select Version"
          (selectionChange)="onVersionSelected($event)"
        >
          <mat-option [value]="null" disabled>{{constants.text.SELECT_VERSION}}</mat-option>
          <mat-option *ngFor="let option of versionsList" [value]="option">
            {{ option.id }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

  </form>
</div>
